
/**
 * simple singleton just to know if the cart was verified
 */
export class CartVerifier {
    public static instance: CartVerifier = new CartVerifier();
    public isVerified: boolean = false;
}